export const DataAttribute = {
	useNativeContextMenu: 'data-use-native-context-menu',
};
